export class RepDates {
    smsdatefrom: string;
    smsdateto: string;
}